import React, { useEffect, useState } from 'react';

import { Cancel, CheckCircle } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const EducationInfo = ({
  data,
  setData,
  education,
  setDisableSave,
  disableSave,
}) => {
  const [verify, setVerify] = useState({});
  const [educationData, setEducationData] = useState([]);

  useEffect(() => {
    if (Object.keys(verify).length > 0) {
      if (education?.length === Object.keys(verify).length) {
        setDisableSave({ ...disableSave, education: false });
      } else {
        setDisableSave({ ...disableSave, education: true });
      }
    }
  }, [verify]);

  useEffect(() => {
    if (educationData.length > 0) {
      setData({
        ...data,
        education: [...educationData],
      });
    }
  }, [educationData]);

  return (
    <>
      <div className=' shadow-xl rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4 text-[#134F5C] text-base font-semibold'>
          Education
        </div>
        {/* </div> */}
        <div className='flex flex-col space-y-10 justify-center w-full py-6'>
          {education?.length > 0 &&
            education.map((exp, index) => {
              return (
                <div className='flex items-center gap-14  px-4' key={index}>
                  <span className=' flex items-center w-3/4'>
                    <span className='ml-2'>
                      <div className=' flex flex-col space-y-1'>
                        <div className=' opacity-80 text-base'>
                          {exp.degree}
                        </div>
                        <div className=' opacity-60 text-sm'>
                          {exp.instituteName}
                        </div>
                        <div className='opacity-50'>{exp.years}</div>
                      </div>
                    </span>
                  </span>
                  <span className='w-1/4 flex items-center justify-between'>
                    <span className=' opacity-60 text-sm'>
                      Education {index + 1}
                    </span>
                    <span>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'yes' });
                          educationData.splice(index, 0, exp);
                          setEducationData([...educationData]);
                        }}
                        className='focus:outline-none'
                      >
                        <CheckCircle
                          htmlColor={
                            verify[index] === 'yes' ? '#76CE65' : 'inherit'
                          }
                        />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'no' });
                          educationData.splice(index, 1);
                          setEducationData([...educationData]);
                        }}
                      >
                        <Cancel
                          htmlColor={
                            verify[index] === 'no' ? '#CC0000' : 'inherit'
                          }
                        />
                      </IconButton>
                    </span>
                  </span>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default EducationInfo;
